// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Image-space1-f_aCD {
	margin-bottom: 6px !important;
}

.Image-space2-MYfWl {
	margin-bottom: 12px !important;
}

.Image-space3-D43Bi {
	margin-bottom: 18px !important;
}

.Image-space4-uoxqc {
	margin-bottom: 24px !important;
}

.Image-space5-aWQxG {
	margin-bottom: 30px !important;
}

.Image-space6-MoLWB {
	margin-bottom: 36px !important;
}

.Image-space7-e3ma_ {
	margin-bottom: 42px !important;
}

.Image-spaceTop8-goNdZ {
	margin-bottom: 48px !important;
}

.Image-spaceTop1-BWlE0 {
	margin-top: 6px !important;
}

.Image-spaceTop2-_R2d8 {
	margin-top: 12px !important;
}

.Image-spaceTop3-vyb1S {
	margin-top: 18px !important;
}

.Image-spaceTop4-q745g {
	margin-top: 24px !important;
}

.Image-spaceTop5-uu2Ra {
	margin-top: 30px !important;
}

.Image-spaceTop6-MwqpI {
	margin-top: 36px !important;
}

.Image-spaceTop7-pca51 {
	margin-top: 42px !important;
}

.Image-spaceTop8-goNdZ {
	margin-top: 48px !important;
}

.Image-noMargin-LbPPG {
	margin: 0px !important;
}

.Image-padding1-brCA3 {
	padding-bottom: 6px !important;
}

.Image-padding2-bmKa6 {
	padding-bottom: 12px !important;
}

.Image-padding3-XQ8mt {
	padding-bottom: 18px !important;
}

.Image-padding4-SgJkn {
	padding-bottom: 24px !important;
}

.Image-padding5-xOqST {
	padding-bottom: 30px !important;
}

.Image-padding6-OMo4m {
	padding-bottom: 36px !important;
}

.Image-padding7-JFNRY {
	padding-bottom: 42px !important;
}

.Image-paddingTop1-nczLa {
	padding-top: 6px !important;
}

.Image-paddingTop2-QWZRd {
	padding-top: 12px !important;
}

.Image-paddingTop3-j3DDR {
	padding-top: 18px !important;
}

.Image-paddingTop4-mB7dr {
	padding-top: 24px !important;
}

.Image-paddingTop5-rxJTn {
	padding-top: 30px !important;
}

.Image-paddingTop6-L_9Hf {
	padding-top: 36px !important;
}

.Image-paddingTop7-_zeol {
	padding-top: 42px !important;
}

.Image-noPadding-eNkW1 {
	padding: 0px !important;
}

.Image-textBold-mfOnP {
	font-weight: 500 !important;
}

.Image-textBolder-QrETz {
	font-weight: 700 !important;
}

.Image-textNormal-MSc_8 {
	font-weight: normal !important;
}

.Image-spaceBottom20-UOjlK {
	margin-bottom: 20px;
}

.Image-spaceBottom10-uAINQ {
	margin-bottom: 10px;
}

.Image-marginNone-Szqa0 {
	margin: 0;
}

.Image-spaceBottom15-L9Ork {
	margin-bottom: 15px;
}

.Image-marginTopNone-wYp7g {
	margin-top: 0;
}

.Image-spaceTop11-yDM1L {
	margin-top: 11px;
}

.Image-spaceTop21-GlBzO {
	margin-top: 21px;
}

.Image-spaceTop20-f5OsK {
	margin-top: 20px;
}

.Image-spaceTop10-V4TKZ {
	margin-top: 10px;
}

/*New Design Text Colors */

.Image-textDarkBlue-zSIsk {
	color: rgb(20, 39, 94) !important;
}

.Image-textLightBlue-DGu3k {
	color: rgb(57, 87, 106) !important;
}

.Image-textLightSandleGreen-hwVsq {
	color: rgb(76, 86, 41) !important;
}

.Image-textLightBrown-eBVlb {
	color: rgb(115, 79, 33) !important;
}

.Image-textMediumMaroon-XwEaO {
	color: rgb(87, 37, 51) !important;
}

.Image-textBrown-AClmJ {
	color: rgb(160, 47, 24) !important;
}

.Image-textMaroon-HvCkF {
	color: rgb(155, 49, 67) !important;
}

.Image-textDarkBrown-dVkF7 {
	color: rgb(83, 18, 16) !important;
}

.Image-textMediumBrown-MAkWF {
	color: rgb(142, 28, 10) !important;
}

.Image-textSkyBlue-PamzQ {
	color: rgb(37, 117, 141) !important;
}

.Image-textGray-GCx40 {
	color: rgb(77, 65, 51) !important;
}

.Image-commonHeaderAdmin-J1AIe {
	position: fixed !important;
}

.Image-adminLayout-CRrQk {
	padding-top: 64px !important;
}

.Image-box-fAarK h2 {
	font-size: 21px;
	font-weight: 600;
}

.Image-exportLink-BdnZR {
	margin-bottom: -29px;
}

.Image-blockCenter-SQ7v4 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.Image-panelHeader-goT67 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.Image-currencyselect-YPHFL {
	width: 100%;
	margin-right: 0px;
}

.Image-panelHeader-goT67 {
	overflow: hidden;
	position: relative;
}

.Image-mar0-FCjtP {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.Image-blockCenter-SQ7v4 {
		padding: 0px;
	}

	.Image-panelHeader-goT67 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.Image-sideAdminPageWrapper-TQzJB {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.Image-panelHeader-goT67 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.Image-table-jN8pv {
	display: table;
}

.Image-tableRow-G2rys {
	display: table-row;
}

.Image-tableCell-l8LFr {
	display: table-cell;
	float: none;
}

.Image-formGroup-PsQtw {
	margin-bottom: 6px;
}

.Image-select-ehBtg {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.Image-noMargin-LbPPG {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.Image-exportLink-BdnZR {
	padding-top: 10px;
	padding-right: 10px;
}

.Image-labelTextNew-oyZtI {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-displayInline-Tq7WU {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.Image-btnUPdate-K1vBx {
	display: inline-block;
}

.Image-btnModalDelete-PC74a {
	display: inline-block;
	margin-left: 15px;
}

.Image-radioBtn-LxaA6 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.Image-backgroundImg-qupBv {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.Image-btnUPdate-K1vBx {
		display: block;
		margin-bottom: 12px;
	}

	.Image-btnModalDelete-PC74a {
		display: block;
		margin-left: 0px;
	}

	.Image-btnWidth-M8Myv {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.Image-bannerImageBg-QlP4W {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.Image-bannerDelete-CAnve {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.Image-modalRoot-ZWJ2N {
	padding: 32px;
}

.Image-modalBorderBottom-s6wkR {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.Image-logInModalBody-b7dGT {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.Image-exportSection-J8tJy {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.Image-exportSectionGridSub-e2fGG {
	grid-template-columns: 50% 49% !important;
}

.Image-exportText-zQUJA {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.Image-exportLinkImg-cnKmZ {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.Image-vtrMiddle-dzlvt {
	vertical-align: middle;
}

.Image-exportImg-mPUUl {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.Image-profileViewlabel-xY7jL {
	display: inline-block;
	width: 38%
}

.Image-profileViewMainContent-sxfhA {
	display: inline-block;
	width: 62%;
}

.Image-profileViewMain-r80nU {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.Image-profileViewInner-JDGsU {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.Image-profileImageSection-RgkfE {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.Image-lastviewInner-Az4Ai {
	padding: 10px;
}

.Image-whyHostHoriLine-u7JOQ {
	margin: 30px 0;
}

.Image-tableGrid-CgMCs {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.Image-headingContent-qq7_p {
	font-size: 18px;
	font-weight: 500;
}

.Image-refundTextColor-Tqr3M {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.Image-dividerLine-gQvpn {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Image-smallContent-qORet {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.Image-sideAdminPageWrapper-TQzJB {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.Image-sideAdminPageWrapper-TQzJB {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.Image-exportSection-J8tJy {
		grid-template-columns: 100%;
	}

	.Image-exportSectionGridSub-e2fGG {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.Image-profileViewlabel-xY7jL {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.Image-profileViewMainContent-sxfhA {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.Image-ChangeToUpperCase-vsiL2 {
	text-transform: uppercase
}

.Image-noBorder-d9RBs {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.Image-siteAdminHeading-xelex {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-siteAdminSubHeading-tt2dM {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.Image-adminFormDivider-bzUiu {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5NA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Image-space1-f_aCD`,
	"space2": `Image-space2-MYfWl`,
	"space3": `Image-space3-D43Bi`,
	"space4": `Image-space4-uoxqc`,
	"space5": `Image-space5-aWQxG`,
	"space6": `Image-space6-MoLWB`,
	"space7": `Image-space7-e3ma_`,
	"spaceTop8": `Image-spaceTop8-goNdZ`,
	"spaceTop1": `Image-spaceTop1-BWlE0`,
	"spaceTop2": `Image-spaceTop2-_R2d8`,
	"spaceTop3": `Image-spaceTop3-vyb1S`,
	"spaceTop4": `Image-spaceTop4-q745g`,
	"spaceTop5": `Image-spaceTop5-uu2Ra`,
	"spaceTop6": `Image-spaceTop6-MwqpI`,
	"spaceTop7": `Image-spaceTop7-pca51`,
	"noMargin": `Image-noMargin-LbPPG`,
	"padding1": `Image-padding1-brCA3`,
	"padding2": `Image-padding2-bmKa6`,
	"padding3": `Image-padding3-XQ8mt`,
	"padding4": `Image-padding4-SgJkn`,
	"padding5": `Image-padding5-xOqST`,
	"padding6": `Image-padding6-OMo4m`,
	"padding7": `Image-padding7-JFNRY`,
	"paddingTop1": `Image-paddingTop1-nczLa`,
	"paddingTop2": `Image-paddingTop2-QWZRd`,
	"paddingTop3": `Image-paddingTop3-j3DDR`,
	"paddingTop4": `Image-paddingTop4-mB7dr`,
	"paddingTop5": `Image-paddingTop5-rxJTn`,
	"paddingTop6": `Image-paddingTop6-L_9Hf`,
	"paddingTop7": `Image-paddingTop7-_zeol`,
	"noPadding": `Image-noPadding-eNkW1`,
	"textBold": `Image-textBold-mfOnP`,
	"textBolder": `Image-textBolder-QrETz`,
	"textNormal": `Image-textNormal-MSc_8`,
	"spaceBottom20": `Image-spaceBottom20-UOjlK`,
	"spaceBottom10": `Image-spaceBottom10-uAINQ`,
	"marginNone": `Image-marginNone-Szqa0`,
	"spaceBottom15": `Image-spaceBottom15-L9Ork`,
	"marginTopNone": `Image-marginTopNone-wYp7g`,
	"spaceTop11": `Image-spaceTop11-yDM1L`,
	"spaceTop21": `Image-spaceTop21-GlBzO`,
	"spaceTop20": `Image-spaceTop20-f5OsK`,
	"spaceTop10": `Image-spaceTop10-V4TKZ`,
	"textDarkBlue": `Image-textDarkBlue-zSIsk`,
	"textLightBlue": `Image-textLightBlue-DGu3k`,
	"textLightSandleGreen": `Image-textLightSandleGreen-hwVsq`,
	"textLightBrown": `Image-textLightBrown-eBVlb`,
	"textMediumMaroon": `Image-textMediumMaroon-XwEaO`,
	"textBrown": `Image-textBrown-AClmJ`,
	"textMaroon": `Image-textMaroon-HvCkF`,
	"textDarkBrown": `Image-textDarkBrown-dVkF7`,
	"textMediumBrown": `Image-textMediumBrown-MAkWF`,
	"textSkyBlue": `Image-textSkyBlue-PamzQ`,
	"textGray": `Image-textGray-GCx40`,
	"commonHeaderAdmin": `Image-commonHeaderAdmin-J1AIe`,
	"adminLayout": `Image-adminLayout-CRrQk`,
	"box": `Image-box-fAarK`,
	"exportLink": `Image-exportLink-BdnZR`,
	"blockCenter": `Image-blockCenter-SQ7v4`,
	"panelHeader": `Image-panelHeader-goT67`,
	"currencyselect": `Image-currencyselect-YPHFL`,
	"mar0": `Image-mar0-FCjtP`,
	"sideAdminPageWrapper": `Image-sideAdminPageWrapper-TQzJB`,
	"table": `Image-table-jN8pv`,
	"tableRow": `Image-tableRow-G2rys`,
	"tableCell": `Image-tableCell-l8LFr`,
	"formGroup": `Image-formGroup-PsQtw`,
	"select": `Image-select-ehBtg`,
	"labelTextNew": `Image-labelTextNew-oyZtI`,
	"displayInline": `Image-displayInline-Tq7WU`,
	"btnUPdate": `Image-btnUPdate-K1vBx`,
	"btnModalDelete": `Image-btnModalDelete-PC74a`,
	"radioBtn": `Image-radioBtn-LxaA6`,
	"backgroundImg": `Image-backgroundImg-qupBv`,
	"btnWidth": `Image-btnWidth-M8Myv`,
	"bannerImageBg": `Image-bannerImageBg-QlP4W`,
	"bannerDelete": `Image-bannerDelete-CAnve`,
	"modalRoot": `Image-modalRoot-ZWJ2N`,
	"modalBorderBottom": `Image-modalBorderBottom-s6wkR`,
	"logInModalBody": `Image-logInModalBody-b7dGT`,
	"exportSection": `Image-exportSection-J8tJy`,
	"exportSectionGridSub": `Image-exportSectionGridSub-e2fGG`,
	"exportText": `Image-exportText-zQUJA`,
	"exportLinkImg": `Image-exportLinkImg-cnKmZ`,
	"vtrMiddle": `Image-vtrMiddle-dzlvt`,
	"exportImg": `Image-exportImg-mPUUl`,
	"profileViewlabel": `Image-profileViewlabel-xY7jL`,
	"profileViewMainContent": `Image-profileViewMainContent-sxfhA`,
	"profileViewMain": `Image-profileViewMain-r80nU`,
	"profileViewInner": `Image-profileViewInner-JDGsU`,
	"profileImageSection": `Image-profileImageSection-RgkfE`,
	"lastviewInner": `Image-lastviewInner-Az4Ai`,
	"whyHostHoriLine": `Image-whyHostHoriLine-u7JOQ`,
	"tableGrid": `Image-tableGrid-CgMCs`,
	"headingContent": `Image-headingContent-qq7_p`,
	"refundTextColor": `Image-refundTextColor-Tqr3M`,
	"dividerLine": `Image-dividerLine-gQvpn`,
	"smallContent": `Image-smallContent-qORet`,
	"ChangeToUpperCase": `Image-ChangeToUpperCase-vsiL2`,
	"noBorder": `Image-noBorder-d9RBs`,
	"siteAdminHeading": `Image-siteAdminHeading-xelex`,
	"siteAdminSubHeading": `Image-siteAdminSubHeading-tt2dM`,
	"adminFormDivider": `Image-adminFormDivider-bzUiu`
};
module.exports = ___CSS_LOADER_EXPORT___;
